import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FaCheckCircle, FaPhone, FaCalendarAlt, FaUser, FaTag } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './SuccessPage.css';

const SuccessPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    // Get form data from navigation state
    if (location.state && location.state.formData) {
      setFormData(location.state.formData);
    } else {
      // If no data, redirect back to form
      navigate('/');
    }
  }, [location.state, navigate]);

  const handleBackToForm = () => {
    navigate('/');
  };

  if (!formData) {
    return (
      <div className="success-page">
        <div className="container">
          <div className="loading">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="success-page">
      <Navbar />
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="success-content"
        >
          {/* Success Icon */}
          <motion.div
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
            className="success-icon"
          >
            <img 
              src="https://storage.googleapis.com/download/storage/v1/b/ct-bucket-prod/o/1757843415899Success%20Check.gif?generation=1757843416019614&alt=media" 
              alt="Success Animation" 
              className="success-gif"
            />
          </motion.div>

          {/* Success Message */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8, ease: "easeOut" }}
            className="success-message"
          >
            <h1>Thank You for Your Interest!</h1>
            <p className="success-description">Your consultation request has been submitted successfully. Our team will contact you within 24 hours to discuss your vocal coaching needs.</p>
          </motion.div>
          

          {/* Your Details Section */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1.6, ease: "easeOut" }}
            className="your-details-section"
          >
            <motion.h3
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 2.0, ease: "easeOut" }}
            >
              Your Details:
            </motion.h3>
            <div className="details-grid">
              <motion.div 
                className="detail-card"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 2.2, ease: "easeOut" }}
              >
                <div className="detail-icon">
                  <FaUser />
                </div>
                <div className="detail-content">
                  <span className="detail-label">Name:</span>
                  <span className="detail-value">{formData.fullName}</span>
                </div>
              </motion.div>
              
              <motion.div 
                className="detail-card"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 2.4, ease: "easeOut" }}
              >
                <div className="detail-icon">
                  <FaPhone />
                </div>
                <div className="detail-content">
                  <span className="detail-label">Phone:</span>
                  <span className="detail-value">{formData.countryCode} {formData.phone}</span>
                </div>
              </motion.div>
              
              <motion.div 
                className="detail-card"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 2.6, ease: "easeOut" }}
              >
                <div className="detail-icon">
                  <FaCalendarAlt />
                </div>
                <div className="detail-content">
                  <span className="detail-label">Training Start:</span>
                  <span className="detail-value">{formData.trainingStartDate}</span>
                </div>
              </motion.div>
              
              <motion.div 
                className="detail-card"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 2.8, ease: "easeOut" }}
              >
                <div className="detail-icon">
                  <FaTag />
                </div>
                <div className="detail-content">
                  <span className="detail-label">Budget:</span>
                  <span className="detail-value">{formData.budget}</span>
                </div>
              </motion.div>
            </div>
          </motion.div>

          {/* Expert Preference */}
          {/* {(formData.specificExpert || formData.customExpert) && (
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 3.0, ease: "easeOut" }}
              className="expert-preference-section"
            >
              <motion.h3
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 3.2, ease: "easeOut" }}
              >
                Expert Preference:
              </motion.h3>
              <motion.div 
                className="expert-preference-card"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 3.4, ease: "easeOut" }}
              >
                <div className="expert-preference-content">
                  <span className="expert-preference-label">Selected Expert:</span>
                  <span className="expert-preference-value">
                    {formData.specificExpert || formData.customExpert || 'Any Expert'}
                  </span>
                </div>
              </motion.div>
            </motion.div>
          )} */}

          {/* Goals Summary */}
          {/* {formData.goals && formData.goals.length > 0 && (
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 3.6, ease: "easeOut" }}
              className="goals-summary"
            >
              <motion.h3
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 3.8, ease: "easeOut" }}
              >
                Your Singing Goals:
              </motion.h3>
              <div className="goals-list">
                {formData.goals.map((goal, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 4.0 + index * 0.1, ease: "easeOut" }}
                    className="goal-item"
                  >
                    <FaCheckCircle className="goal-check" />
                    <span>{goal}</span>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          )} */}

          {/* Next Steps */}
          {/* <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 1 }}
            className="next-steps"
          >
            <h3>What Happens Next?</h3>
            <div className="steps-list">
              <div className="step-item">
                <div className="step-number">1</div>
                <div className="step-content">
                  <h4>Review Your Request</h4>
                  <p>Our team will review your consultation request and match you with the perfect vocal coach.</p>
                </div>
              </div>
              
              <div className="step-item">
                <div className="step-number">2</div>
                <div className="step-content">
                  <h4>Schedule Consultation</h4>
                  <p>We'll contact you within 24 hours to schedule your free consultation call.</p>
                </div>
              </div>
              
              <div className="step-item">
                <div className="step-number">3</div>
                <div className="step-content">
                  <h4>Start Your Journey</h4>
                  <p>Begin your personalized vocal coaching journey with industry experts.</p>
                </div>
              </div>
            </div>
          </motion.div> */}

          {/* Action Buttons */}
          {/* <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 1.2 }}
            className="success-actions"
          >
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleBackToForm}
              className="btn btn-secondary"
            >
              Submit Another Request
            </motion.button>
          </motion.div> */}
        </motion.div>
      </div>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default SuccessPage;
